import {
  Box,
  Button,
  Container,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import Choferbuscar from "../Choferbuscar";
import Camionbuscar from "../Camionbuscar";
import Tanquebuscar from "../Tanquebuscar";
const buttonStyles = (disabled) => ({
  textTransform: "none", // Evita que se ponga en mayúsculas
  fontWeight: 500,
  fontSize: "1rem",
  padding: "8px 20px",
  borderRadius: "8px",
  backgroundColor: disabled ? "#B0B0B0" : "#1976d2",
  color: "#fff",
  boxShadow: disabled ? "none" : "0px 2px 6px rgba(0,0,0,0.2)",
  "&:hover": {
    backgroundColor: disabled ? "#B0B0B0" : "#1565c0",
  },
  "&:active": {
    transform: disabled ? "none" : "scale(0.98)",
    boxShadow: disabled ? "none" : "0px 1px 4px rgba(0,0,0,0.2)",
  },
  transition: "all 0.2s ease",
});

const VerificarAccesoForm = ({
  dniDelChofer,
  setDniDelChofer,
  patenteDelCamion,
  setPatenteDelCamion,
  patenteDelTanque,
  setPatenteDelTanque,
  handleSubmit,
}) => {
  //#region Objeto para mappear el TextFields

  const inputsToRender = [
    {
      label: "Patente del camión",
      value: patenteDelCamion,
      onChange: (e) => setPatenteDelCamion(e.target.value.trim()),
      type: "text",
    },
    {
      label: "Patente del tanque",
      value: patenteDelTanque,
      onChange: (e) => setPatenteDelTanque(e.target.value.trim()),
      type: "text",
    },
    {
      label: "DNI del chofer",
      value: dniDelChofer,
      onChange: (e) => setDniDelChofer(e.target.value.trim()),
      type: "text",
    },
  ];
  //#endregion

  const disabled = !(
    dniDelChofer &&
    dniDelChofer.length >= 6 &&
    patenteDelCamion &&
    patenteDelCamion.length >= 6 &&
    patenteDelTanque &&
    patenteDelTanque.length >= 6
  );

  return (
    <Container
      sx={{
        display: "flex",
        flexDirection: "column",
        sm: { maxWidth: "90vh" },
        mt: 4,
        pb: 2,
        borderRadius: "20px",
        boxShadow: 3,
      }}
    >
      <Typography
        variant="h2"
        component="h2"
        gutterBottom
        sx={{ py: 4, fontSize: "2.25rem" }}
      >
        Filtros de Búsqueda
      </Typography>
      <Grid container spacing={2} sx={{ mb: 2 }}>
        {/* {inputsToRender.map((input, index) => (
          <Grid item xs={12} md={4} key={index}>
            <TextField
              InputLabelProps={{ shrink: true }}
              type={input.type}
              label={input.label}
              value={input.value}
              onChange={input.onChange}
              fullWidth
            />
          </Grid>
        ))} */}

       <Grid item xs={12} md={4}>
       <Camionbuscar
       value={patenteDelCamion}
       onChange={setPatenteDelCamion}
      />
       </Grid>

      < Grid item xs={12} md={4}>
       <Tanquebuscar
          value={patenteDelTanque}
          onChange={setPatenteDelTanque}
        />
        </Grid>

      <Grid item xs={12} md={4}>
      <Choferbuscar
        value={dniDelChofer}
        onChange={setDniDelChofer}
        />
      </Grid>
        
      </Grid>
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          sx={buttonStyles(disabled)}
          onClick={handleSubmit}
          disabled={disabled}
        >
          Buscar
        </Button>
      </Box>
    </Container>
  );
};

export default VerificarAccesoForm;
